import { createSlice } from "@reduxjs/toolkit";
import { DetalhesResultadoSorteioModel } from "../../../models/resultadoSorteio/detalhesResultadoSorteioModel";
import { ResultadoModel } from "../../../models/resultadoSorteio/resultadoModel";
import { ResultadoSorteioDadosModel } from "../../../models/resultadoSorteio/resultadoSorteioDadosModel";
import { ResultadoSorteioVMModel } from "../../../models/resultadoSorteio/resultadoSorteioVMModel";
import { StatusResultadoSorteioModel } from "../../../models/resultadoSorteio/statusResultadoSorteioModel";
import { buscarResultadoSorteio, carregarDados, detalhaResultadoSorteio, listarStatusResultadoSorteio } from "../../../services/resultadoSorteioService";
import { resetAll, resetPersistedState } from "../../actions/actions";

var dateObj = new Date();
export interface ResultadoSorteioState {
  //carregar dados
  loading: boolean;
  busca: ResultadoSorteioDadosModel;
  resultado: ResultadoModel;
  //buscar resultado sorteio
  loadingResultado: boolean;
  resultadoSorteio: ResultadoSorteioVMModel[];
  //buscar detalhe resultado sorteio
  loadingDetalhe: boolean;
  detalheResultadoSorteio: DetalhesResultadoSorteioModel[];
  //buscar status resultado sorteio
  loadingStatus: boolean;
  statusResultadoSorteio: StatusResultadoSorteioModel[];
  //internal
  idSorteio: number | null;
  idEmpresa: number;
  planoContaFinanceiro: {
    id: number;
    denominacao: string;
  } | null;
  dataSorteio: Date;
  comesFromResultado: boolean;
  tipoResultado: string;
  modalHistorico: boolean;
  modalAtencao: boolean;
  modalContasComsaldo: boolean;
  modalReiniciar: boolean;
}

const initialState: ResultadoSorteioState = {
  //carregar dados
  loading: false,
  busca: {
    idSorteio: null,
    tipoCalculoResultado: "e",
  } as ResultadoSorteioDadosModel,
  resultado: {} as ResultadoModel,
  //buscar resultado sorteio
  loadingResultado: false,
  resultadoSorteio: [],
  //buscar detalhe resultado sorteio
  loadingDetalhe: false,
  detalheResultadoSorteio: [],
  //buscar status resultado sorteio
  loadingStatus: false,
  statusResultadoSorteio: [],
  //internal
  idSorteio: null,
  idEmpresa: 0,
  planoContaFinanceiro: null,
  dataSorteio: new Date(dateObj.getFullYear(), dateObj.getMonth() + 1, 0),
  comesFromResultado: false,
  tipoResultado: "e",
  modalHistorico: false,
  modalAtencao: false,
  modalContasComsaldo: false,
  modalReiniciar: false,
};

export const resultadoSorteioSlice = createSlice({
  name: "resultadoSorteio",
  initialState,
  reducers: {
    //carregar dados
    setBuscaResultadoSorteio: (state, action) => {
      state.busca = action.payload;
    },
    //internal
    setIdSorteio: (state, action) => {
      state.idSorteio = action.payload;
    },
    setIdEmpresa: (state, action) => {
      state.idEmpresa = action.payload;
    },
    setPlanoContaFinanceiro: (state, action) => {
      state.planoContaFinanceiro = action.payload;
    },
    setComesFromResultado: (state, action) => {
      state.comesFromResultado = action.payload;
    },
    setDataSorteio: (state, action) => {
      state.dataSorteio = action.payload;
    },
    setTipoResultado: (state, action) => {
      state.tipoResultado = action.payload;
    },
    setModalHistoricoResultadoSorteio: (state, action) => {
      state.modalHistorico = action.payload;
    },
    setModalAtencaoResultadoSorteio: (state, action) => {
      state.modalAtencao = action.payload;
    },
    setModalContasComsaldoResultadoSorteio: (state, action) => {
      state.modalContasComsaldo = action.payload;
    },
    setModalReiniciarResultadoSorteio: (state, action) => {
      state.modalReiniciar = action.payload;
    },
    resetOnRadioChange: (state) => {
      state.loading = false;
      state.loadingResultado = false;
      state.resultado = {} as ResultadoModel;
      state.detalheResultadoSorteio = [];
      state.busca = {
        idSorteio: null,
        tipoCalculoResultado: "e",
      } as ResultadoSorteioDadosModel;
      state.planoContaFinanceiro = null;
      state.comesFromResultado = false;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, (state) => {
      state.planoContaFinanceiro = null;
      state.comesFromResultado = false;
    });

    //quando é disparado o resetAll nas mudanças de menu, ele não reseta o estado inicial, por isso a necessidade de disparar o resetPersistedState ao sair da aplicação, resetando o estado inicial desse slice
    builder.addCase(resetPersistedState, () => initialState);

    //carregar dados
    builder.addCase(carregarDados.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(carregarDados.fulfilled, (state, action) => {
      state.resultado = action.payload;
      state.loading = false;
    });
    builder.addCase(carregarDados.rejected, (state, action) => {
      state.loading = false;
    });

    //buscar resultado
    builder.addCase(buscarResultadoSorteio.pending, (state) => {
      state.loadingResultado = true;
    });
    builder.addCase(buscarResultadoSorteio.fulfilled, (state, action) => {
      state.resultadoSorteio = action.payload;
      state.loadingResultado = false;
    });
    builder.addCase(buscarResultadoSorteio.rejected, (state, action) => {
      state.loadingResultado = false;
    });

    //detalhe resultado
    builder.addCase(detalhaResultadoSorteio.pending, (state) => {
      state.loadingDetalhe = true;
    });
    builder.addCase(detalhaResultadoSorteio.fulfilled, (state, action) => {
      state.detalheResultadoSorteio = action.payload;
      state.loadingDetalhe = false;
    });
    builder.addCase(detalhaResultadoSorteio.rejected, (state, action) => {
      state.loadingDetalhe = false;
    });

    //listar status resultado
    builder.addCase(listarStatusResultadoSorteio.pending, (state) => {
      state.loadingStatus = true;
    });
    builder.addCase(listarStatusResultadoSorteio.fulfilled, (state, action) => {
      state.statusResultadoSorteio = action.payload;
      state.loadingStatus = false;
    });
    builder.addCase(listarStatusResultadoSorteio.rejected, (state, action) => {
      state.loadingStatus = false;
    });
  },
});

export const {
  //carregar dados
  setBuscaResultadoSorteio,
  //internal
  setIdSorteio,
  setIdEmpresa,
  setPlanoContaFinanceiro,
  setComesFromResultado,
  setDataSorteio,
  setTipoResultado,
  setModalHistoricoResultadoSorteio,
  setModalAtencaoResultadoSorteio,
  setModalContasComsaldoResultadoSorteio,
  setModalReiniciarResultadoSorteio,
  resetOnRadioChange,
} = resultadoSorteioSlice.actions;

export default resultadoSorteioSlice.reducer;
